import ResourceList from './ResourceList.component';

export default ResourceList;
